import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbMissionGlobal, AloDbMissionGlobalCoverage, AloDbMissionGlobalFormation, AloDbMissionGlobalSimulation } from '@/models/alodb/AloDbMissionGlobal'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { ISmartMission } from '@/models/iris/smartMission/ISmartMission'
import { ISmartSimulation, getDefaultSmartSimulation } from '@/models/iris/smartMission/ISmartSimulation'
import { MissionPlanUiState } from '@/models/ui/MissionPlanUiState'
import { cloneDeep } from 'lodash'
import mission from '../mission'
import { ISmartSimulationCoverage } from '@/models/iris/smartMission/ISmartSimulationCoverage'
import { DepRecoMode } from '@/enum/DepRecoMode'
import { ISmartSimulationFormation } from '@/models/iris/smartMission/ISmartSimulationFormation'

export default {  
  getMissionGlobals(): AxiosPromise<AlrContainer<AloBaseArray<AloDbMissionGlobal>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/missionglobal', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbMissionGlobal>>(JSON.parse(data),AloDbMissionGlobal.createAloDbMissionGlobalArray)
      }]
    })
  },
  getMissionGlobal(id:number):AxiosPromise<AlrContainer<AloDbMissionGlobal>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/missionglobal/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbMissionGlobal>(JSON.parse(data),AloDbMissionGlobal.createAloDbMissionGlobalWithDetail)
      }]
    })
  },
  saveMissionGlobal(missionGlobal:AloDbMissionGlobal):AxiosPromise<AlrContainer<AloDbMissionGlobal>> {
    if(missionGlobal.config) missionGlobal.MIG_JSON = JSON.stringify(missionGlobal.config)
    if(missionGlobal.MIG_ID && missionGlobal.MIG_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/missionglobal/${missionGlobal.MIG_ID}`, 
        method: 'PUT',
        data: missionGlobal,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMissionGlobal>(JSON.parse(data),AloDbMissionGlobal.createAloDbMissionGlobalWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/missionglobal`, 
        method: 'POST',
        data: missionGlobal,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMissionGlobal>(JSON.parse(data),AloDbMissionGlobal.createAloDbMissionGlobalWithDetail)
        }]
      })    
    }
    
  },
  deleteMissionGlobal(id:number,cascading:boolean = false):AxiosPromise<AlrContainer<AloDbMissionGlobal>> {    
    return  apiHelpers.apiCall({ 
      url: `api/admin/missionglobal/${id}`, 
      method: 'DELETE',      
      params: {cascading},
      transformResponse: [function (data:string) {          
        return new AlrContainer<any>(JSON.parse(data),i => i)
      }]
    })       
  },
  addMissionGlobalLayerLink(migId:number,layId:number): AxiosPromise<any> {    
    return apiHelpers.apiCall({ 
      url: `api/missionglobal/${migId}/maplayer/${layId}`, 
      method: 'POST'
    })
  },  
  deleteMissionGlobalLayerLink(migId:number,layId:number): AxiosPromise<any> {    
    return apiHelpers.apiCall({ 
      url: `api/missionglobal/${migId}/maplayer/${layId}`, 
      method: 'DELETE'
    })
  }, 
  runSimulation(missionGlobal:AloDbMissionGlobalSimulation) {    
    //On verifie que les parametre son ok
    const data = cloneDeep(missionGlobal.config!) as ISmartSimulation // {...getDefaultSmartSimulation(), ...JSON.parse(missionGlobal.MIG_JSON!)} as ISmartSimulation                
    //affecte la valeur par default au step courant
    //@ts-ignore
    //supprime l'info de missionPlanTemplate
    delete data.templateSimId

    //@ts-ignore
    if(data.mission_plan.cur_step == -1) data.mission_plan.cur_step = data.mission_plan?.steps?.at(0)?.id ?? -1
    //s'assure du bon format des nav
    data.mission_plan.prf_nav = data.mission_plan.prf_nav.map(pn => ({...MissionPlanUiState.getDefaultProfil(),...pn}))
    
    //s'assure du bon format des prfSci et qu'ils soient bien lié à un sensor valide
    data.mission_plan.prf_sci = data.mission_plan.prf_sci.map(ps => {
        const p = {...MissionPlanUiState.getDefaultProfilSci(),...ps}                
        const newSensors = {} as {[index:number]:any}      
        Object.keys(p.sensors).forEach(k =>{          
          const id = Number.parseInt(k)
          if(!isNaN(id)) {
            const sensor = p.sensors[Number.parseInt(k)]
            //@ts-ignore
            newSensors[id] = [sensor?.at(0) ?? 1, sensor?.at(1)?.toString()?.padStart(3,'0') ?? "111",sensor?.at(2) ?? 1]
          }          
        }) 
        p.sensors = newSensors    
        return p
    })

    //s'assure que les prfSciId soit null si payload false ou inexistant sur les steps
    data.mission_plan.steps.forEach(s => {
      //@ts-ignore
      if(!s.payload_enable || (s?.prfSci_id ?? null) == null) s.prfSci_id = null
    })   
    
    //@ts-ignore
    const wptInit = data.mission_plan.steps.length > 0?data.mission_plan.wpts.find(w => w.id == data.mission_plan.steps?.at(0)?.wpt_id):data.mission_plan.wpts?.at(0)

    data.wpt_init = [wptInit?.wpt_lat ?? 0,wptInit?.wpt_lon ?? 0]
    
    //remise à jour des paramètres du glider
    //@ts-ignore
    data.glider_type = data.gliders_config?.at(0)?.glider_type ?? data.glider_type
    //@ts-ignore
    data.battery_type = data.gliders_config?.at(0)?.battery_type ?? data.battery_type
    //@ts-ignore
    data.bms_type = data.gliders_config?.at(0)?.bms_type ?? data.bms_type
        
    return  apiHelpers.apiCall({ 
      url: `/api/iris/processingSimulator/${missionGlobal.MIG_ID}`, 
      method: 'POST',
      data,
      transformResponse: [function (data:string) {       
        return new AlrContainer<ISmartMission>(JSON.parse(data),(d)=>d)                   
      }]
    })    
  },
  processCoverageGrid(missionGlobal:AloDbMissionGlobalCoverage) {
    //On verifie que les parametre son ok
    const data = cloneDeep(missionGlobal.config!) as ISmartSimulationCoverage // {...getDefaultSmartSimulation(), ...JSON.parse(missionGlobal.MIG_JSON!)} as ISmartSimulation                
    const param = {
      processing_mode: "pathcoverage",
      processing_step: "GridGeneration",
      coverage_area : {        
          area : data.coverage_area.map(p => [p.wpt_lat,p.wpt_lon]),
          excluded_areas : data.exclude_areas.map(e => e.area_pts.map(p => [p.wpt_lat,p.wpt_lon])),
          mesh_size : data.grid_size * 1000
     }
    }
    return  apiHelpers.apiCall({ 
      url: `/api/iris/processingCoverageGrid/${missionGlobal.MIG_ID}`, 
      method: 'POST',
      data: param/*,
      transformResponse: [function (data:string) {       
        return new AlrContainer<IrisrawProcessCoverageGrid>(JSON.parse(data),(d)=>d)
      }]*/
    })
  },
  processCoverageSimulation(missionGlobal:AloDbMissionGlobalCoverage) {
    //On verifie que les parametre son ok
    const data = cloneDeep(missionGlobal.config!) as ISmartSimulationCoverage // {...getDefaultSmartSimulation(), ...JSON.parse(missionGlobal.MIG_JSON!)} as ISmartSimulation                    
    console.log(data.gliders_config)
   
    const param = {
      processing_mode: "pathcoverage",
      processing_step: "MatrixGeneration",      
	    mission_start_date: data.mission_start_date,
	    surfacing_time: data.surfacing_time,
	    glider_number: data.gliders_config.length,
	    common_deployment : data.deployment_mode == DepRecoMode.common,
	    common_recovery : data.recovery_mode == DepRecoMode.common,
      deployment_point: data.deployment_point,          
      recovery_point: data.recovery_point,         
      enable_science_files: data.enable_science_files,         
      resolution_time : data.resolution_time,
	    gliders_config: data.gliders_config.reduce((config,gc,idx) => {
        const payload = gc.payload.map((s,idx) => ({id:idx+1,snr_label:s})) ?? []
        config[`GLIDER${idx+1}`] = {
          battery_type: gc.battery_type,
        	bms_type: gc.bms_type,
        	glider_type: gc.glider_type,
        	libelle: `GLIDER${idx+1}`,
        	start_energy: gc.start_energy, 
          end_battery_percent: gc.end_battery_percent,
          payload: payload,
          prf_nav: gc?.prf_nav?.map((pn,idx) => ({...pn,id:idx+1})) ?? [{...MissionPlanUiState.getDefaultProfil(),id:1}],                            
          prf_sci: gc.prf_sci?.map((pr,idx) => ({...pr,id:idx+1, sensors:payload?.reduce((s,p)=>{s[p.id] = pr.sensors[p.snr_label] ?? [1,"111",1];return s},{} as {[key:number]:[number,string,number]})}))          
                            ?? [{id:1,prf_label:"default",sensors:payload?.reduce((s,p) => {s[p.id] = [1,"111",1]; return s},{} as {[key:number]:[number,string,number]})}]
        }
        return config
      },{} as {[index:string]:any}),      
    }
    return  apiHelpers.apiCall({ 
      url: `/api/iris/processingCoverageFull/${missionGlobal.MIG_ID}`, 
      method: 'POST',
      data: param,      
      transformResponse: [function (data:string) {       
        return new AlrContainer<ISmartSimulationCoverage>(JSON.parse(data),(d)=>d)                   
      }]
    })
  },
  processFormationSimulation(missionGlobal:AloDbMissionGlobalFormation) {
    const data = cloneDeep(missionGlobal.config!) as ISmartSimulationFormation // {...getDefaultSmartSimulation(), ...JSON.parse(missionGlobal.MIG_JSON!)} as ISmartSimulation                    
    console.log(data.gliders_config)
    
    //@ts-ignore
    if(data.mission_plan.cur_step == -1) data.mission_plan.cur_step = data.mission_plan?.steps?.at(0)?.id ?? -1
    //s'assure du bon format des nav
    data.mission_plan.prf_nav = data.mission_plan.prf_nav.map(pn => ({...MissionPlanUiState.getDefaultProfil(),...pn}))
    
    //s'assure du bon format des prfSci et qu'ils soient bien lié à un sensor valide
    data.mission_plan.prf_sci = []

    //s'assure que les prfSciId soit null si payload false ou inexistant sur les steps
    data.mission_plan.steps.forEach(s => {
      //@ts-ignore
      s.prfSci_id = null
    })   
    
    //@ts-ignore
    const wptInit = data.mission_plan.steps.length > 0?data.mission_plan.wpts.find(w => w.id == data.mission_plan.steps?.at(0)?.wpt_id):data.mission_plan.wpts?.at(0)

    data.wpt_init = [wptInit?.wpt_lat ?? 0,wptInit?.wpt_lon ?? 0]


    const param = {
      processing_mode: "keepformation",      
	    mission_start_date: data.mission_start_date,
	    surfacing_time: data.surfacing_time,
	    glider_number: data.gliders_config.length,	                
      //number_of_glider: data.gliders_config.length,	                
      enable_science_files: data.enable_science_files,      
      offsets: data.offsets,
      //wpt_init:[wptInit?.wpt_lat ?? 0,wptInit?.wpt_lon ?? 0],
	    gliders_config: data.gliders_config.reduce((config,gc,idx) => {
        const payload = gc.payload.map((s,idx) => ({id:idx+1,snr_label:s})) ?? []
        config[`GLIDER${idx+1}`] = {
          battery_type: gc.battery_type,
        	bms_type: gc.bms_type,
        	glider_type: gc.glider_type,
        	libelle: `GLIDER${idx+1}`,
        	start_energy: gc.start_energy,        	          
          end_battery_percent: gc.end_battery_percent,
          payload: payload,          
          prf_sci: gc.prf_sci?.map((pr,idx) => ({...pr,id:idx+1, sensors:payload?.reduce((s,p)=>{s[p.id] = pr.sensors[p.snr_label] ?? [1,"111",1];return s},{} as {[key:number]:[number,string,number]})}))          
                            ?? [{id:1,prf_label:"default",sensors:payload?.reduce((s,p) => {s[p.id] = [1,"111",1]; return s},{} as {[key:number]:[number,string,number]})}]
        }
        return config
      },{} as {[index:string]:any}),   
      barycentre_mission_plan:data.mission_plan
    }
    return  apiHelpers.apiCall({ 
      url: `/api/iris/IrisProcessingFormationFull/${missionGlobal.MIG_ID}`, 
      method: 'POST',
      data: param,      
      transformResponse: [function (data:string) {       
        return new AlrContainer<ISmartSimulationFormation>(JSON.parse(data),(d)=>d)                   
      }]
    })

  },
  abortSimulation(missionGlobal:AloDbMissionGlobal) {
    return  apiHelpers.apiCall({ 
      url: `/api/iris/abortSimulator/${missionGlobal.MIG_ID}`, 
      method: 'PUT',
      transformResponse: [function (data:string) {       
        return new AlrContainer<ISmartMission>(JSON.parse(data),(d)=>d)                   
      }]
    })    
  }
  
}